<h2 matDialogTitle>Add details</h2>

<mat-dialog-content>
  <mat-form-field fxFlex>
    <input
      type="text"
      matInput
      [(ngModel)]="selectedLabel"
      (ngModelChange)="filter(selectedLabel)"
      [matAutocomplete]="labelAuto"
      placeholder="Detail"
    />
  </mat-form-field>

  <mat-autocomplete #labelAuto="matAutocomplete">
    <mat-option *ngFor="let label of filteredData" [value]="label.name">
      {{ label.name }}
    </mat-option>
  </mat-autocomplete>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-button matDialogClose>Cancel</button>
  <button mat-raised-button color="primary" matDialogClose="{{ selectedLabel }}">Add</button>
</mat-dialog-actions>
